module.exports = __webpack_public_path__ + "assets/images/english.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/english.png
// module id = 401
// module chunks = 1